export const CHECKBOX = 'CHECKBOX';
export const DATE = 'DATE';
export const SCALE = 'SCALE';
export const RADIO = 'RADIO';
export const ATTACHMENT = 'ATTACHMENT';
export const NUMBER_FIELD = 'NUMBER_FIELD';
export const TEXT_FIELD = 'TEXT_FIELD';
export const PASSWORD_FIELD = 'PASSWORD_FIELD';
export const SELECT_LOOKUP = 'SELECT_LOOKUP';
export const SELECT_ENUM = 'SELECT_ENUM';
export const AUTOCOMPLETE = 'AUTOCOMPLETE';
export const HIDDEN = 'HIDDEN';
export const LINK = 'LINK';
export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';



// WEBPACK FOOTER //
// ./src/constants/InputTypes.js